import patientBillingService from '../../../../../services/patientBilling.service';
import { MeContext } from '../../../../../contexts/me.context';
import { useContext } from 'react';
import { QueryFunctionContext, useQuery } from 'react-query';
import useServices from '../../visits/notes/services/useServices';

const getQuery = function (clinicId: number) {
  return async (context: QueryFunctionContext) => {
    const billingKey = context.queryKey[1] as string;
    return patientBillingService.getPatientTransaction(clinicId, billingKey);
  };
};

export const useTransaction = function (billingKey?: string) {
  const { me } = useContext(MeContext);
  const { status, data, isFetching, refetch } = useQuery(
    ['transaction', billingKey],
    getQuery(me?.selectedClinic?.ID || -1),
    {
      refetchOnWindowFocus: false,
      retry: false,
    },
  );
  const { data: services } = useServices({ billingKey: billingKey });

  return {
    status,
    data,
    services,
    isFetching,
    refetch,
  };
};
